import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from 'ionic-angular';

/**
 * Generated class for the YoutubeIframeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'youtube-iframe',
  templateUrl: 'youtube-iframe.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YoutubeIframeComponent {

  @Input() video: string;

  constructor(public sanitizer: DomSanitizer, public platform: Platform) {
    console.log('Hello YoutubeIframeComponent Component');
  }

  showVideoUrl(url: string) {
    // Appending an ID to a YouTube URL is safe.
    // Always make sure to construct SafeValue objects as
    // close as possible to the input data, so
    // that it's easier to check if the value is safe.
    //https://www.youtube.com/watch?v=vKRKDhvbDDo
    if (url) {
      const matchUrl = url.match("v=([a-zA-Z0-9\_\-]+)&?") || url.match("https://youtu.be/([a-zA-Z0-9\_\-]+)&?");
      const code = matchUrl ? matchUrl[1] : '';
      if (code) {
        let dangerousVideoUrl = 'https://www.youtube.com/embed/' + code;
        return this.sanitizer.bypassSecurityTrustResourceUrl(dangerousVideoUrl);
      }
    }
  }

  isIOS() {
    return (this.platform.is('cordova') && this.platform.is('ios'));
  }

}



// WEBPACK FOOTER //
// ./src/components/youtube-iframe/youtube-iframe.ts